import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { i18n } from 'i18n'
import { getLang } from 'i18n/config/LanguageDetector'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { getColorTranslation } from 'page/StartScreen/combine/utils'
import { ReactElement } from 'react'
import { opt } from 'store/opt'
import { getItemShapeLabel, ItemData } from 'type/Inference'
import { notNil } from 'util/null'

type Props = {
  item: ItemData
  shape: boolean
  combo: boolean
}

export const ItemTitle = observer((props: Props): ReactElement | undefined => {
  const { item, combo } = props
  const { hide_name_for_en, tsum, boutique, combine } = opt.options
  const shape = props.shape && !tsum ? getItemShapeLabel(item) : undefined
  const { article, brand, product, color } = item
  const lang = getLang()
  const hide_name = combine && combo && lang === 'en' && hide_name_for_en
  const show_article = article && tsum && boutique
  const show_color = color && tsum && boutique

  return <Vertical gap={4} center oh>
    {shape && <Typo one size={opt.stand ? 11 : 8} medium upper>
      {shape}
    </Typo>}
    {show_article && <Space gap={4}>
      <Icon name="barcode" size={12} secondary />
      <Typo one size={opt.stand ? 11 : 9} secondary upper>
        {article}
      </Typo>
    </Space>}
    <Vertical wide center oh>
      {brand && <Typo size={opt.stand ? 13 : 10} secondary upper center balance>
        {brand}
      </Typo>}
      {product && !hide_name && <Typo size={opt.stand ? 20 : 14} medium upper center balance clamp>
        {product}
      </Typo>}
    </Vertical>
    {show_color && <Space gap={4}>
      <Typo size={opt.stand ? 11 : 9} secondary upper>{i18n('Color')}:</Typo>
      <Typo size={opt.stand ? 11 : 9} upper>{getColorTranslation(color)}</Typo>
    </Space>}
  </Vertical>
})

export function renderItemTitles(items: ItemData[]) {
  const shape = items.length > 1
  const combo = items.length > 1
  const elements = items.map(item => {
    const { brand, product } = item
    if (!brand && !product) return undefined
    return <ItemTitle item={item} shape={shape} combo={combo} />
  }).filter(notNil)
  return elements.length ? elements : undefined
}
